import FormBuilder from '../../components/FormBuilder';

// Form Ekle sayfası — standart sayfa başlığı + form yapılandırıcı kartı; FormBuilder mantığına dokunulmaz.
export default function FormCreatePage({ createForm }) {
  return (
    <section className="form-create-page">
      <div className="section-header">
        <div>
          <h2>Form Ekle</h2>
          <p className="muted">
            Bölümleri ve alanları tanımlayın. Kaydettiğiniz şablon, bir kalıba bağlandığında kullanıcılar tarafından doldurulabilir.
          </p>
        </div>
      </div>

      <div className="form-create-builder">
        <div className="form-create-builder-body">
          <FormBuilder onSave={createForm} />
        </div>
      </div>
    </section>
  );
}
